import React from 'react';
import OnboardingStepWrapper from '../OnboardingStepWrapper';
import LottieAnimation from '../../LottieAnimation';
import { useOnboarding, ONBOARDING_STEPS } from '../../../context/OnboardingContext';
import { MultipleChoice } from '@orbit/ui';
import type { OnboardingData } from '../../../context/OnboardingContext';

interface InitialSelectionProps {
  showGlow?: boolean;
}

const options: { id: 'existing-idea' | 'need-ideas'; title: string }[] = [
  { id: 'existing-idea', title: 'I already have a business idea' },
  { id: 'need-ideas', title: 'I need help coming up with ideas' },
];

const InitialSelection: React.FC<InitialSelectionProps> = ({ showGlow = true }) => {
  const { setData, setStep } = useOnboarding();

  const handleSelection = (option: { id: string; title: string }) => {
    const choice = option.id as OnboardingData['initialChoice'];

    // Store the choice
    setData({ initialChoice: choice });

    // Navigate directly based on the choice
    if (choice === 'existing-idea') {
      setStep(ONBOARDING_STEPS.USER_BUSINESS_IDEA);
    } else if (choice === 'need-ideas') {
      setStep(ONBOARDING_STEPS.USER_BIO_FORM);
    }
  };

  const cardShadow = showGlow
    ? 'shadow-[0_4px_16px_0_rgba(36,137,249,0.18)] hover:shadow-[0_6px_24px_0_rgba(36,137,249,0.28)]'
    : '';

  // Don't show back button on the first step
  const showBackButton = false;

  return (
    <OnboardingStepWrapper
      title="Ready for Takeoff..."
      subtitle="Select the option that best describes you"
      backgroundChildren={
        <>
          <style>{`
            @media (max-width: 640px) {
              .moon-lottie {
                width: 200px !important;
                height: 200px !important;
                right: -50px !important;
                top: -40px !important;
              }
            }
            @media (min-width: 641px) {
              .moon-lottie {
                width: 480px !important;
                height: 480px !important;
                right: -160px !important;
                top: -200px !important;
              }
            }
          `}</style>
          <div
            className="moon-lottie"
            style={{
              position: 'fixed',
              right: '-160px',
              top: '-200px',
              zIndex: 1,
              pointerEvents: 'none',
            }}
            aria-hidden
          >
            <LottieAnimation
              src="/src/assets/lottie/pulsating_moon.lottie"
              style={{ width: '100%', height: '100%' }}
            />
          </div>
        </>
      }
      showBackButton={showBackButton}
    >
      <MultipleChoice
        options={options}
        onSelect={(option) => handleSelection(option)}
        showGlow={showGlow}
      />
    </OnboardingStepWrapper>
  );
};

export default InitialSelection;
